import { Component, OnInit } from "@angular/core";

import { CookieService } from "ngx-cookie-service";
import { BaseComponent } from "./shared/components/base.component";
import { LookAndFeelService } from "./shared/services/look-and-feel.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent extends BaseComponent implements OnInit {

    constructor(private lnfService: LookAndFeelService) { super()}

    setLnFToCss(landf: object) {
        let root = document.documentElement;
        // set all colors from lnf json
        let colors = landf['colors'];
        let graphics = landf['graphics'];

        for (let color in colors) {
            if (colors.hasOwnProperty(color)) {
                root.style.setProperty('--' + color, colors[color]);
            }
        }

        for (let graphic in graphics) {
            if (graphics.hasOwnProperty(graphic)) {
                root.style.setProperty('--' + graphic, 'url("' + graphics[graphic] + '")');
            }
        }
    }

    ngOnInit() {
        this.lnfService.lnf$.pipe(this.autoDispose()).subscribe(lnf => { if (lnf) this.setLnFToCss(lnf) })
    }
}
